import { useTranslation } from "react-i18next";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { PageHero } from "@/components/site/shared";
import { QuoteForm } from "@/components/site/QuoteForm";
import { CONTACT_EMAIL, WHATSAPP_LINK } from "@/data/site";

export default function Contact() {
  const { t } = useTranslation();
  return (
    <div data-testid="contact-page">
      <PageHero kicker={t("contact.kicker")} title={t("contact.title")} subtitle={t("contact.subtitle")} testId="contact-hero" />

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            <QuoteForm />
          </div>

          <div className="lg:col-span-2 space-y-6" data-testid="direct-contact-block">
            <h2 className="font-heading text-2xl font-extrabold tracking-tight">{t("contact.directTitle")}</h2>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 border bg-card p-5 hover:border-primary transition-colors group"
              data-testid="contact-whatsapp-card"
            >
              <MessageCircle className="h-6 w-6 text-primary shrink-0" />
              <div>
                <p className="text-xs uppercase tracking-widest text-muted-foreground">{t("contact.whatsapp")}</p>
                <p className="font-heading font-bold group-hover:text-primary transition-colors">+62 813-3113-1286</p>
                <p className="text-xs text-muted-foreground">{t("contact.chat")}</p>
              </div>
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="flex items-center gap-4 border bg-card p-5 hover:border-primary transition-colors group"
              data-testid="contact-email-card"
            >
              <Mail className="h-6 w-6 text-primary shrink-0" />
              <div>
                <p className="text-xs uppercase tracking-widest text-muted-foreground">{t("contact.email")}</p>
                <p className="font-heading font-bold group-hover:text-primary transition-colors">{CONTACT_EMAIL}</p>
              </div>
            </a>
            <div className="flex items-center gap-4 border bg-card p-5" data-testid="contact-office-card">
              <MapPin className="h-6 w-6 text-primary shrink-0" />
              <div>
                <p className="text-xs uppercase tracking-widest text-muted-foreground">{t("contact.office")}</p>
                <p className="font-heading font-bold">{t("contact.officeValue")}</p>
              </div>
            </div>
            <div className="border overflow-hidden">
              <iframe
                title="ANSEN Indonesia Office"
                src="https://maps.google.com/maps?q=Kebomas,%20Gresik,%20East%20Java,%20Indonesia&z=13&output=embed"
                className="w-full h-[260px] border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
